// angular
import { NgClass, NgOptimizedImage } from '@angular/common';
import { Component, inject, input, OnChanges } from '@angular/core';
// components
import {
  GalleryDialogComponent,
  getGalleryDialogConfig,
} from '@app/core/dialogs/gallery-dialog/gallery-dialog.component';
// services
import { DialogService } from '@app/core/shared/services/dialog.service';
// interface
import { IMedia } from '@app/shared/interfaces/media.interface';
// pipes
import { ImageSourcePipe } from '@app/shared/pipes/image-source.pipe';
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';
import { SimpleVideoBoxComponent } from '../simple-video-box/simple-video-box.component';
import { MediaImageFallbackDirective } from '@app/shared/directives/media-image-fallback.directive';

@Component({
  selector: 'pwj-gallery',
  standalone: true,
  imports: [
    NgOptimizedImage,
    ImageSourcePipe,
    NgClass,
    TranslateDataPipe,
    SimpleVideoBoxComponent,
    MediaImageFallbackDirective,
  ],
  templateUrl: './gallery.component.html',
  styleUrl: './gallery.component.scss',
})
export class GalleryComponent implements OnChanges {
  public selectedPreview!: IMedia;
  // inputs
  mediaData = input<IMedia[]>();
  mediaListCount = input<number>(4);
  isColumnListMode = input<boolean>(false);
  useOriginalUrl = input<boolean>(false);

  previewWidth = input<string>('536');
  previewHeight = input<string>('338');

  previewWidthClass = input<string>('w-536');
  previewHeightClass = input<string>('h-338');

  listImgWidth = input<string>('88');
  listImgHeight = input<string>('88');

  listImgWidthClass = input<string>('w-88');
  listImgHeightClass = input<string>('h-88');

  previewAlt = input<string>();
  previewPriority = input<boolean>(false);

  // dependencies
  private readonly _dialogService = inject(DialogService);

  constructor() {}

  ngOnChanges() {
    // set main image
    this.onSelectPreview(this.mediaData()?.[0] as IMedia);
  }

  public onSelectPreview(media: IMedia) {
    this.selectedPreview = media;
  }

  public openGalleryDialog() {
    this._dialogService.open(
      GalleryDialogComponent,
      getGalleryDialogConfig({
        title: 'global.gallery',
        mediaData: this.mediaData(),
        useOriginalUrl: this.useOriginalUrl(),
      })
    );
  }
}
